import {getCourses, getCourse, getLesson, getTopic, getUser} from "./api";
import {Auth} from "aws-amplify";
import {defer} from 'react-router';


export async function authenticationLoader() {
  try {
    const user = await Auth.currentAuthenticatedUser();
    const userResponse = await getUser();
    const {
      license_is_active = false,
    } = userResponse || {};

    const {attributes = {}} = user || {};
    const {sub = null} = attributes || {};

    if (license_is_active) {
      window.sessionStorage.removeItem("missing_license")
    }
    else {
      window.sessionStorage.setItem("missing_license", sub)
    }

    return {license_is_active, user}
  } catch (error) {
    return {error};
  }
}

export async function userLoader() {
  try {
    const userResponse = await getUser();
    const {
      user = {},
      license = null,
      license_is_active = false,
    } = userResponse || {};

    const {Username: sub = {}} = user || {};

    if (license_is_active) {
      window.sessionStorage.removeItem("missing_license")
    }
    else {
      window.sessionStorage.setItem("missing_license", sub)
    }

    return {user, license, license_is_active}
  } catch (error) {
    return {error};
  }
}

export async function coursesLoader() {
  try {
    const coursesData = await getCourses();
    const {
      data: courses = [],
    } = coursesData || {};
    return {courses};
  } catch (error) {
    return {error};
  }
}

export async function courseLoader({params = {}}) {
  const {
    courseId = null,
  } = params || {};

  return defer({
    courseId: parseInt(courseId),
    course: getCourse(courseId),
  })
}

export async function lessonLoader({params = {}}) {
  const {
    courseId = null,
    lessonId = null,
  } = params || {};

  try {
    const lesson = await getLesson(lessonId);
    return {
      courseId: parseInt(courseId),
      lessonId: parseInt(lessonId),
      lesson,
    };
  } catch (error) {
    return {
      courseId: parseInt(lessonId),
      lessonId: parseInt(lessonId),
      error,
    };
  }
}

export async function topicLoader({params = {}}) {
  const {
    courseId = null,
    lessonId = null,
    topicId = null,
  } = params || {};

  try {
    const topic = await getTopic(topicId);
    return {
      courseId: parseInt(courseId),
      lessonId: parseInt(lessonId),
      topicId: parseInt(topicId),
      topic,
    };
  } catch (error) {
    return {
      courseId: parseInt(courseId),
      lessonId: parseInt(lessonId),
      topicId: parseInt(topicId),
      error,
    };
  }
}